import { render, staticRenderFns } from "./user-requests.view.vue?vue&type=template&id=794621ca&scoped=true&"
import script from "./user-requests.view.ts?vue&type=script&lang=ts&"
export * from "./user-requests.view.ts?vue&type=script&lang=ts&"
import style0 from "./user-requests.view.scss?vue&type=style&index=0&id=794621ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794621ca",
  null
  
)

export default component.exports